<script>import * as d3 from "d3";
import Swatch from "./Swatch.svelte";
export let title = void 0;
export let scale;
export let type = "square";
export let orientation = "row";
export let column = "unset";
export let size = "1rem";
</script>

<div
  class="swatches {orientation}"
  style=" --size:{size}; --column:{column};"
>
  {#if title}
    <span class="title">{title}</span>
  {/if}
  <div class="container">
    {#each scale.domain() as label, i (label)}<div
        class="swatch {type}"
        title={label}
      ><Swatch color={scale(label)} {type} {size}/><span class="label">{label}</span></div>{/each}
  </div>
</div>

<style>
  div.swatches {
    --title-font-size: 0.6875rem;
    --swatch-width: var(--size);
    --swatch-height: var(--size);
    --swatch-border-radius: 0.25rem;
    --swatch-font-sizex: 0.625rem;
    --swatch-font-size: 0.875rem;
    --swatch-total-max-width: var(--column);
  }

  span.title {
    font-weight: bold;
    font-size: var(--title-font-size);
  }
  div.swatches:not(.column) div.container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  div.swatch {
    vertical-align: top;
    line-height: var(--swatch-height);
    height: var(--swatch-height);
    max-width: var(--swatch-total-max-width);
    width: var(--swatch-total-max-width);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  div.swatches.row div.swatch {
    padding-right: 1rem;
  }
  div.swatches div.swatch {
    margin-bottom: 0.25rem;
  }
  div.swatch > .label {
    vertical-align: top;
    display: inline-block;
    font-size: var(--swatch-font-size);
    line-height: var(--swatch-height);
    margin-left: 0.25rem;
  }

</style>
